var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37695 7.49077H17.5592",
    stroke: "#FAFAFA",
    strokeWidth: 1.02302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.859 10.5983H13.8664",
    stroke: "#FAFAFA",
    strokeWidth: 2.72806,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3942 10.5983H10.4015",
    stroke: "#FAFAFA",
    strokeWidth: 2.72806,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92933 10.5978H6.9367",
    stroke: "#FAFAFA",
    strokeWidth: 2.72806,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.859 14.0786H13.8664",
    stroke: "#FAFAFA",
    strokeWidth: 2.72806,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3942 14.0786H10.4015",
    stroke: "#FAFAFA",
    strokeWidth: 2.72806,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92933 14.0786H6.9367",
    stroke: "#FAFAFA",
    strokeWidth: 2.72806,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6811 1.59937V4.21779",
    stroke: "#FAFAFA",
    strokeWidth: 1.02302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25333 1.59937V4.21779",
    stroke: "#FAFAFA",
    strokeWidth: 1.02302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8362 2.85583H7.09891C4.76224 2.85583 3.30273 4.15752 3.30273 6.55022V13.7509C3.30273 16.1812 4.76224 17.513 7.09891 17.513H13.8288C16.1729 17.513 17.625 16.2038 17.625 13.8111V6.55022C17.6324 4.15752 16.1803 2.85583 13.8362 2.85583Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.02302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b2a21af5c2d45b71936332d5b2a5639e.svg";
export { ForwardRef as ReactComponent };